// extracted by mini-css-extract-plugin
export default {"dot":"hXBBYouNf_sxD2RruSOh"};